/* eslint-disable no-unused-vars */
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import Upsert from '../../../components/form/Upsert'
import Modal from '../../../components/popup/Modal'

const ChuyenDieuChinh = (props) => {
  const { onSubmit, visible, toggle, header } = props
  const [data, setData] = useState({})
  const [error, setError] = useState({})

  useEffect(() => {
    setData({})
  }, [visible])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
      <Button
        onClick={async () => {
          if (!data.noiDung) {
            setError({ noiDung: 'Nội dung không được để trống' })
            return
          }
          if (onSubmit) onSubmit(data)
          toggle()
        }}
        label="Lưu"
      />
    </div>
  )

  return (
    <>
      <Modal header={header || 'Phản hồi'} visible={visible} toggle={toggle} footer={footer}>
        <div className="mt-2">
          <Upsert
            fields={['noiDung', 'file']}
            name={{ noiDung: 'Nội dung', file: 'File đính kèm' }}
            types={{ noiDung: 'text-area', file: 'file' }}
            col={{ noiDung: 12, file: 12 }}
            error={error}
            setError={setError}
            values={data}
            setValues={setData}
          />
        </div>
      </Modal>
    </>
  )
}
export default ChuyenDieuChinh
